import { MdCheckCircle } from 'react-icons/md';

interface CampaignSentPanelProps {
  campaignName: string;
  recipientCount: number;
  sendAt: string;
  campaignId: string;
  onStartAnother: () => void;
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between gap-4 border-t border-gray-100 py-2 text-sm">
      <span className="text-gray-500">{label}</span>
      <span className="text-right font-medium text-gray-900">{value}</span>
    </div>
  );
}

export default function CampaignSentPanel({
  campaignName,
  recipientCount,
  sendAt,
  campaignId,
  onStartAnother,
}: CampaignSentPanelProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <div className="mb-4 flex items-center gap-2">
        <MdCheckCircle size={22} className="text-green-600" />
        <h2 className="text-base font-medium text-gray-900">
          Recipients uploaded
        </h2>
      </div>
      <p className="mb-4 text-sm text-gray-500">
        Nothing else reports back to this page, so keep the comms id if you need
        to ask about this send later.
      </p>

      <Row label="Comms" value={campaignName} />
      <Row label="People" value={String(recipientCount)} />
      <Row label="Sending" value={sendAt} />
      <Row label="Comms id" value={campaignId} />

      <button
        type="button"
        onClick={onStartAnother}
        className="mt-6 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Start another
      </button>
    </div>
  );
}
